module.exports = __webpack_public_path__ + "img/powerGOA.453afe99.jpg";